import api from './../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const devicesStartRequest = () => {
  return {
    type: 'DEVICES_START_REQUEST'
  };
};

export const devicesEndRequest = () => {
  return {
    type: 'DEVICES_END_REQUEST'
  };
};

export const getAllDevicesSuccess = ({ data }) => {
  return {
    type: 'DEVICES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllDevicesError = error => {
  return {
    type: 'DEVICES_GET_ALL_ERROR',
    payload: error
  };
};

export const addDevicesSuccess = ({ data }) => {
  return {
    type: 'DEVICES_ADD_SUCCESS',
    payload: data
  };
};

export const addDevicesError = error => {
  return {
    type: 'DEVICES_ADD_ERROR',
    payload: error
  };
};

export const editDevicesSuccess = ({ data }) => {
  return {
    type: 'DEVICES_EDIT_SUCCESS',
    payload: data
  };
};

export const editDevicesError = error => {
  return {
    type: 'DEVICES_EDIT_ERROR',
    payload: error
  };
};

export const removeDevicesSuccess = id => {
  return {
    type: 'DEVICES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeDevicesError = error => {
  return {
    type: 'DEVICES_REMOVE_ERROR',
    payload: error
  };
};

export const groupConfigsSuccess = ({ data }) => {
  return {
    type: 'DEVICES_GROUP_CONFIG_SUCCESS',
    payload: data
  };
};

export const groupConfigsError = error => {
  return {
    type: 'DEVICES_GROUP_CONFIG_ERROR',
    payload: error
  };
};

export const groupSyncSuccess = ({ data }) => {
  return {
    type: 'DEVICES_GROUP_SYNC_SUCCESS',
    payload: data
  };
};

export const groupSyncError = error => {
  return {
    type: 'DEVICES_GROUP_SYNC_ERROR',
    payload: error
  };
};

export const devicesUpdateItemStore = data => {
  return {
    type: 'DEVICES_UPDATE_ITEM_STORE',
    payload: data
  };
};

export const devicesModifyStore = ({ data }) => {
  return {
    type: 'DEVICES_MODIFY_STORE',
    payload: data
  };
};

export const addDevices = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(devicesStartRequest());
      const response = await api().post('/api/devices', data);
      dispatch(addDevicesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'devices',
        data: response.data
      });
      formReset();
    } catch (err) {
      dispatch(addDevicesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(devicesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllDevices = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(devicesStartRequest());
      const response = await api().get('/api/devices', { params });
      dispatch(getAllDevicesSuccess(response));
    } catch (err) {
      dispatch(getAllDevicesError(err));
    } finally {
      dispatch(devicesEndRequest());
    }
  };
};

export const editDevices = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(devicesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(devicesStartRequest());
      const id = data._id;
      const response = await api().put('/api/devices/' + id, data);
      dispatch(editDevicesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'devices',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/devices'));
      }
    } catch (err) {
      dispatch(editDevicesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeDevices = id => {
  return async dispatch => {
    try {
      dispatch(devicesStartRequest());
      await api().delete('/api/devices/' + id);
      dispatch(removeDevicesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'devices',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Dispositivo removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeDevicesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover dispositivo.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(devicesEndRequest());
    }
  };
};

export const groupConfigs = (data, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(devicesStartRequest());
      const response = await api().post('/api/group/config', data);
      dispatch(groupConfigsSuccess(response));
      const members = data.groupMembers.map(extensionId => ({
        extension: extensionId
      }));
      const obj = {
        ...data,
        _id: data.device,
        groupMembers: members
      };
      dispatch(devicesUpdateItemStore(obj));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'devices',
        data: [obj]
      });
    } catch (err) {
      dispatch(groupConfigsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(devicesEndRequest());
        submitBtn.disabled = false;
      }, 2100);
    }
  };
};

export const restoreDevices = data => {
  return async dispatch => {
    try {
      dispatch(devicesStartRequest());
      const id = data._id;
      const response = await api().put('/api/devices/' + id, data);
      dispatch(editDevicesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'devices',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Dispositivo restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editDevicesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar dispositivo.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(devicesEndRequest());
    }
  };
};

export const groupSync = (data, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(devicesStartRequest());
      const responseSync = await api().post('/api/group/sync', data);
      const responseDevices = await api().get('/api/devices');
      dispatch(getAllDevicesSuccess(responseDevices));
      dispatch(groupSyncSuccess(responseSync));
    } catch (err) {
      dispatch(groupSyncError(err));
    } finally {
      dispatch(devicesEndRequest());
      submitBtn.disabled = false;
    }
  };
};
